import axios from "axios";

export default {
    create: function(data) {
        return axios.post(`${process.env.REACT_APP_API}api/v4/coupons`, data)
            .then(response => {
                return {
                    id: response.data.data.id.toString(),
                    content: response.data.data
                }
            })
    },
    validate: function(data) {
        return axios.post(`${process.env.REACT_APP_API}api/v4/coupons/validate`, data)
            .then(response => {
                return {
                    id: response.data.data.id.toString(),
                    content: response.data.data
                }
            })
    }
}